export default __webpack_public_path__ + "static/media/NeoPenViewerBackImg.f94eab35.png";